module.exports = __webpack_public_path__ + "img/sweden-cardiovascular-diseases-female.3342ce36.png";